import { apiFetch } from "./api";
import { AuthUser } from "../context/useAuth";
import { ManagedUser, CreateUserPayload, PortalAccess } from "../types/user";

export async function fetchUser(email: string): Promise<AuthUser> {
  const u = await apiFetch<any>(`/users/${email}`);
  return {
    email:         u.email,
    role:          u.role,
    name:          `${u.user_first_name ?? ""} ${u.user_last_name ?? ""}`.trim(),
    portal_access: u.portal_access,
    is_active:     u.is_active ?? true,
  };
}

export async function fetchAllUsers(params?: {
  limit?:  number;
  offset?: number;
}): Promise<{ users: ManagedUser[]; total: number }> {
  const q = new URLSearchParams();
  if (params?.limit  != null) q.set("limit",  String(params.limit));
  if (params?.offset != null) q.set("offset", String(params.offset));
  return apiFetch(`/users?${q}`);
}

export async function createUser(payload: CreateUserPayload): Promise<ManagedUser> {
  return apiFetch("/users", { method: "POST", body: JSON.stringify(payload) });
}

export async function updateUserRole(
  email: string, role: "admin" | "reviewer", updatedBy: string,
): Promise<void> {
  await apiFetch(`/users/${email}/role`, {
    method: "PATCH",
    body:   JSON.stringify({ role, updated_by: updatedBy }),
  });
}

export async function updateUserStatus(
  email: string, isActive: boolean, updatedBy: string,
): Promise<void> {
  await apiFetch(`/users/${email}/status`, {
    method: "PATCH",
    body:   JSON.stringify({ is_active: isActive, updated_by: updatedBy }),
  });
}

export async function updatePortalAccess(
  email: string, portalAccess: PortalAccess, updatedBy: string,
): Promise<void> {
  await apiFetch(`/users/${email}/portal-access`, {
    method: "PATCH",
    body:   JSON.stringify({ portal_access: portalAccess, updated_by: updatedBy }),
  });
}
